import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";

const PrivateRoute1stYear = ({ children }) => {
  const { isLoggedIn, userData } = useSelector(
    (state) => state.auth
  );

  if (!userData) {
    return <div>Loading...</div>;
  }

  console.log("Private Route chla");

  const course = window.location.pathname.split("/")[2];
  console.log("course : ", course);

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  const admissions = userData?.admissions || [];
  const admissionLength = admissions.length;


  const isCurrentYearAdmission = (admission) => {
    if (!admission) return false;
    const admissionYear = new Date(admission.created_at).getFullYear();
    const currentYear = new Date().getFullYear();
    return admissionYear === currentYear;
  };


  if (admissionLength === 0) {
    console.log("No admissions found, redirecting to /");
    return <Navigate to="/" replace />;
  }


  if (admissionLength > 0) {
    const latestAdmission = admissions[admissions.length - 1];
    
   
    if (isCurrentYearAdmission(latestAdmission)) {
      console.log("Form already filled for current year, redirecting to /admission-form");
      return <Navigate to="/admission-form" replace />;
    }
  }



  const userCourse =
    userData?.admissions?.[0]?.course === "1"
      ? "ba"
      : userData?.admissions?.[0]?.course === "2"
      ? "bsc"
      : "bcom";

  
  if (userCourse !== course) {
    console.log("Invalid course selection, redirecting to correct course");
    const part = admissionLength === 1 ? "part-2" : "part-3";
    return <Navigate to={`/admission-form/${userCourse}/${part}`} replace />;
  }

  console.log("Valid route, rendering children");
  return children;
};

export default PrivateRoute1stYear;